<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="row">

  <div class="columnnbv1">
    <div class="position-fixed-scans2 border-right2  height-100pe">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 padding-right-0px">
        <!--<div class="row"></div>-->
        <div class="card height-100vh">
          <div class="card-header wh-header border-bottom padding-bottom-0px">
            <div class="row">
              <div class="col-md-12">
                <label class="margin-bottom-0px">Patient Details</label>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row border-bottom-2px" *ngIf="SelectedPatientFormattedCode">
              <!--<div class="padding-left-14px padding-right-14px padding-bottom-14px"></div>-->
              <!--<div class="card"></div>-->
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="row">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <img class="img-circle-50" [src]='SelectedPatientFormattedCode.PatientImageFile' onError="this.src='dummy.jpg';">
                    <!--<img class="img-circle-50" src="DR SITARAM.jpg" onError="this.src='dummy.jpg';">-->
                  </div>
                </div>
                <div class="row margin-left-zero margin-top-10">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px">{{SelectedPatientFormattedCode.DisplayName}}</label>
                  </div>
                </div>
                <div class="row margin-left-zero">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px">{{SelectedPatientFormattedCode.Gender}}/{{SelectedPatientFormattedCode.Age}}</label>
                  </div>
                </div>
                <div class="row margin-left-zero">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px">{{SelectedPatientFormattedCode.FormattedCode}}</label>
                  </div>

                </div>
                <div class="row margin-left-zero">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px">{{SelectedPatientFormattedCode.Telephone1}}</label>
                  </div>

                </div>

              </div>
            </div>


            <div class="row border-bottom-2px margin-top-10">

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="row border-bottom-2px">
                  <div class="col-md-9">
                    <label class="margin-bottom-0px font-weight-normal">Doctor's</label>
                  </div>
                  <!--<div class="col-md-2">
                    <a (click)="docedit()" class="nav-link-hand education-navlink" title="Edit Plan">
                      <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                    </a>
                  </div>-->
                </div>

                <div class="row margin-top-10">
                  <div class="col-md-10">
                    <label class="margin-bottom-0px font-weight-normal">Prescribing Doctor</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-9 padding-left-0px">
                    <div class="row margin-left-0px" *ngFor="let l of CurrentPrescribingDoctor">
                      <label class="margin-bottom-0px f2 td-elipsis-appoinment1">{{l.DoctorName}}</label>
                    </div>

                    <div class="row margin-left-0px" *ngIf="Prescriberdesg">
                      <label class="margin-bottom-0px font-size-11px">{{Prescriberdesg}}</label>
                    </div>

                  </div>

                </div>
                <div class="row">
                  <div class="col-md-10">
                    <label class="margin-bottom-0px font-weight-normal"></label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10">
                    <label class="margin-bottom-0px font-weight-normal">Referring Doctor</label>
                  </div>
                </div>
                <div class="row margin-bottom-10px">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-9 padding-left-0px">
                    <div class="row margin-left-0px" *ngIf="Referalname">
                      <label class="margin-bottom-0px f2 td-elipsis-appoinment1">{{Referalname}}</label>
                    </div>

                    <div class="row margin-left-0px" *ngIf="Referaldesg">
                      <label class="margin-bottom-0px font-size-11px">{{Referaldesg}}</label>
                    </div>

                  </div>
                </div>
              </div>

            </div>
            <div class="row" *ngIf="BillStatus!='PP'">

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="row margin-top-10">
                  <div class="col-md-6">
                    <label class="margin-bottom-0px font-size-12px font-weight-bold data-color-new">Total Bill</label>
                  </div>:
                  <div class="col-md-5 padding-right-0px">
                    <label class="margin-bottom-0px f2 color-Assign " *ngIf="TotalBill">{{TotalBill| number:'1.0-2'|removeComma}}</label>

                    <!--<label class="margin-bottom-0px f2 color-Assign " *ngIf="CurrentNewBillData">{{CurrentNewBillData.TotalBill| number:'1.0'|removeComma}}</label>-->
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <label class="margin-bottom-0px font-size-12px font-weight-bold data-color-new">Discount</label>
                  </div>:
                  <div class="col-md-5 padding-right-0px">
                    <label class="margin-bottom-0px f2 color-Assign" *ngIf="Tdiscount">{{Tdiscount| number:'1.0-2'|removeComma}}</label>

                    <!--<label class="margin-bottom-0px f2 color-Assign" *ngIf="CurrentNewBillData">{{CurrentNewBillData.TotalDiscount| number:'1.0'|removeComma}}</label>-->
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <label class="margin-bottom-0px font-size-12px font-weight-bold data-color-new">Net Payable</label>
                  </div>:
                  <div class="col-md-5 padding-right-0px">
                    <label class="margin-bottom-0px f2 color-Assign" *ngIf="NetPayable">{{NetPayable}}</label>

                    <!--<label class="margin-bottom-0px f2 color-Assign" *ngIf="CurrentNewBillData">{{CurrentNewBillData.NetPayable| number:'1.0'|removeComma}}</label>-->
                  </div>
                </div>
              </div>

            </div>

          </div>

        </div>

      </div>
    </div>
  </div>

  <div class="columnnbv2  margin-top-17px">
    <div class="card height-100vh ">
      <div class="card-header wh-header  padding-bottom-0px padding-left-0px padding-right-0px padding-t-6px header-fixed">
        <div class="row border-bottom padding-bottom-5px margin-left-0px margin-right-0px">
          <div class="col-md-4">
            <label class="margin-bottom-0px margin-left-5px">Edit Bill</label>
          </div>
          <!--<div class="col-md-3">
            <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
          </div>-->

          <div class="offset-md-2 col-md-6 float-right">
            <div class="row">
              <div class="col-md-4 padding-right-0px">
                <!--<search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>-->
              </div>
              <div class="col-md-8 padding-left-0px" *ngIf="ChargeEntryCodeModal==0 && BillStatus=='NP'">
                <button type="button" class="btn btn-secondary float-right  font-size-13px margin-left-5px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="Cancel()">Back</button>
                <button type="button" class="btn btn-secondary float-right  font-size-13px margin-left-5px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="CancelBill()">Cancel Bill</button>
                <button class="btn actions-btn-prime font-size-13px margin-left-5px float-right" (click)="Payment()" *ngIf="LChargeEntryCode!=0"><i class="fas fa-rupee-sign nav-link-hand font-size-12px margin-top-5px"></i> Pay</button>
                <button *canUserAccess="['HL_BL_12']" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" (click)="AddData()" >Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>

              </div>
              <div class="col-md-8 padding-left-0px" *ngIf="ChargeEntryCodeModal==0 && BillStatus!='NP'">
                <button type="button" class="btn btn-secondary float-right  font-size-13px margin-left-5px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="Cancel()">Back</button>
                <button class="btn actions-btn-prime font-size-13px margin-left-5px float-right" (click)="Payment()" *ngIf="LChargeEntryCode!=0"><i class="fas fa-rupee-sign nav-link-hand font-size-12px margin-top-5px"></i> Pay</button>

              </div>
              <div class="col-md-8 padding-left-0px" *ngIf="ChargeEntryCodeModal>0">
                <div class="row">
                  <div class="col-md-12">
                    <button class="btn actions-btn-prime font-size-13px margin-left-5px float-right" (click)="Cancel()">View Bills</button>
                    <button *canUserAccess="['HL_BL_16']" type="submit" class="btn btn-profile float-right actions-btn-prime-profile2 font-size-13px margin-right-5px" (click)="rxbill()">
                      <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> A4
                    </button>
                  </div>
                  <!--<div class="col-md-6">
                    <button class="btn actions-btn-prime font-size-13px margin-left-5px float-right" (click)="Cancel()">View Bills</button>
                  </div>-->
                </div>

              </div>
            </div>
            <!--<button type="submit" class="btn actions-btn-prime font-size-13px margin-left-5px float-right"><i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> Print</button>-->



          </div>

        </div>
        <div class="row border-top border-bottom bk-color-light margin-left-0px margin-right-0px">
          <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
            <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Bill Date</label></div>
            <div><label class="margin-bottom-0px font-size-16px color-Assign" *ngIf="Date">{{Date| date:'MMM-dd-yyyy'}}</label></div>
          </div>
          <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
            <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Branch</label></div>
            <div><label class="margin-bottom-0px font-size-16px color-Assign" *ngIf="BranchName">{{BranchName}}</label></div>
          </div>
          <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
            <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Total Bill</label></div>
            <div><label class="margin-bottom-0px font-size-16px color-Assign" *ngIf="TotalBill">{{TotalBill| number:'1.0-2'|removeComma}}</label></div>
          </div>

          <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
            <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Discount</label></div>
            <div><label class="margin-bottom-0px font-size-16px color-Assign" *ngIf="Tdiscount">{{Tdiscount| number:'1.0-2'|removeComma}}</label></div>
          </div>
          <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
            <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Total Tax</label></div>
            <div><label class="margin-bottom-0px font-size-16px color-Assign" *ngIf="TotalTax">{{TotalTax| number:'1.0-2'|removeComma}}</label></div>
          </div>
          <!--<div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center" *ngIf="BillStatus=='NP'">
            <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Net PayableNp</label></div>
            <div><label class="margin-bottom-0px font-size-16px color-Assign" *ngIf="NetPayable">{{NetPayable}}</label></div>
          </div>-->
          <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
            <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Net Payable</label></div>
            <div><label class="margin-bottom-0px font-size-16px color-Assign" *ngIf="NetPayable">{{NetPayable}} </label></div>
          </div>
        </div>
      </div>
      <div class="card-body  padding-bottom-0px padding-left-0px padding-right-0px padding-top-92px">


        <!--<div class="row">
          <div class="col-md-12">
            <div class="table-component margin-bottom-0px">
              <div class="table-responsive overflow-x">


                <table class="table table-striped margin-left-20p table-fixed"
                       cols="auto,2*,*,*,*,*,*,*">

                  <thead class="">
                    <tr>

                      <th class="min-width-24px padding-top-4px padding-bottom-4px th-sticky">
                        #
                      </th>


                      <th class="padding-top-4px padding-bottom-4px th-sticky">
                        Service Description
                      </th>
                      <th class="padding-top-4px padding-bottom-4px th-sticky">
                        QTY
                      </th>

                      <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                        Unit Price
                      </th>

                      <th class="padding-top-4px padding-bottom-4px th-sticky">
                        Discount
                      </th>

                      <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                        Item Rate
                      </th>

                      <th class="padding-top-4px padding-bottom-4px th-sticky">

                      </th>






                    </tr>
                  </thead>





                </table>
              </div>
            </div>
          </div>
        </div>-->
        <!--<div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="card">


              <div class="card-header wh-header border-bottom padding-bottom-0px">
                <div class="row border-bottom">
                  <div class="col-md-12">
                    <label class="margin-bottom-0px">Payment</label>
                  </div>

                </div>
              </div>
              <div class="card-body padding-top-5px padding-bottom-0px">
                <div class="row">

                    <div class="col-md-12 padding-right-0px">
                      <div class="table-component">
                        <div class="table-responsive">


                          <table class="table table-striped margin-left-zero width-100">

                            <thead class="">
                              <tr>

                                <th class="min-width-0px"></th>
                                <th class="th-width-170px">Amount</th>

                                <th class="th-width-170px">Charges</th>
                                <th class="th-width-170px">Ref.No</th>
                                <th>Details</th>
                              </tr>
                            </thead>
                            <tbody class="table-body">

                              <tr>
                                <td class="td-padding">

                                    <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                           [(ngModel)]="cash" />
                                    <i class="input-helper"></i>

                                    <label class="margin-bottom-0px position-absoulte margin-top-2px">Cash</label>



                                </td>
                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cash">
                                </td>
                                <td class="text-align-right">
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cash">
                                </td>

                                <td class="td-padding ">

                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cash">

                                </td>

                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cash">
                                </td>



                              </tr>
                              <tr>
                                <td class="td-padding">

                                  <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                         [(ngModel)]="card" />
                                  <i class="input-helper"></i>
                                  <label class="margin-bottom-0px position-absoulte margin-top-2px">Card</label>

                                </td>
                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="card">
                                </td>
                                <td class="text-align-right">
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="card">
                                </td>

                                <td class="td-padding ">

                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="card">

                                </td>

                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="card">
                                </td>



                              </tr>
                              <tr>
                                <td class="td-padding">


                                  <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                         [(ngModel)]="cheque" />
                                  <i class="input-helper"></i>
                                  <label class="margin-bottom-0px position-absoulte margin-top-2px">Cheque</label>

                                </td>
                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cheque">
                                </td>
                                <td class="text-align-right">
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cheque">
                                </td>

                                <td class="td-padding ">

                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cheque">

                                </td>

                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cheque">
                                </td>



                              </tr>
                              <tr>
                                <td class="td-padding">

                                  <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                         [(ngModel)]="demanddraft" />
                                  <i class="input-helper"></i>
                                  <label class="margin-bottom-0px position-absoulte margin-top-2px">Demand Draft</label>

                                </td>
                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="demanddraft">
                                </td>
                                <td class="text-align-right">
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="demanddraft">
                                </td>

                                <td class="td-padding ">

                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="demanddraft">

                                </td>

                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="demanddraft">
                                </td>



                              </tr>
                              <tr>
                                <td class="td-padding">

                                  <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                         [(ngModel)]="paytm" />
                                  <i class="input-helper"></i>
                                  <label class="margin-bottom-0px position-absoulte margin-top-2px">Paytm</label>

                                </td>
                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="paytm">
                                </td>
                                <td class="text-align-right">
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="paytm">
                                </td>

                                <td class="td-padding ">

                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="paytm">

                                </td>

                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="paytm">
                                </td>



                              </tr>
                            </tbody>

                          </table>

                        </div>
                      </div>
                    </div>

                </div>
                                       </div>






            </div>
          </div>
        </div>-->

        <div class="chatsd product-chart-wrapper agreement-chart-wrapper ps2 padding-lrt height-80pe">
          <div class="row padding-top-3px">
            <div class="col-md-12">
              <div class="table-component">
                <div class="table-responsive overflow-x">


                  <table class="table table-striped margin-left-20p table-fixed"
                         cols="auto,2*,*,*,*,*,*,*">

                    <thead class="">
                      <tr>

                        <th class="min-width-24px padding-top-4px padding-bottom-4px th-sticky">
                          #
                        </th>


                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                          Service Description
                        </th>
                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                          QTY
                        </th>

                        <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                          Unit Price
                        </th>
                        <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                          Item Total
                        </th>
                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                          Disc %
                        </th>
                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                          Net
                        </th>

                        <!--<th class="">

                        </th>-->
                        <th class="padding-top-4px padding-bottom-4px th-sticky">

                        </th>






                      </tr>
                    </thead>

                    <tbody class="table-body">
                      <tr *ngFor="let l of CurrentBillDetails;let i = index">


                        <td class="td-padding-tb">
                          {{i+1}}
                        </td>
                        <td class=" td-padding-tb">
                          <div>{{l.ServiceDescription}}</div>
                          <div class="patientreg-link margin-left-3px">Batch : {{l.SupplierBatchDetails}}</div>
                        </td>

                        <td class="text-align-center td-padding-tb">
                          <!--<input type="number" class="form-control text-align-right td-width-82px" placeholder=""
                          [(ngModel)]="l.quantity"
                          maxlength="2" required>-->
                          <!--<label *ngIf="!l.Edit" class="margin-bottom-0px">{{l.Quantity}}</label>-->
                          <!--<input  type="number" class="form-control text-align-right td-width-82px" placeholder=""
                          [(ngModel)]="l.Quantity"
                          maxlength="2" required>-->
                          <!--<CodeTypeValue CodeType="1to5"
                                         id="l.Quantity" (keyChange)="Qunatitychange(l)"
                                         [(ngModel)]="l.Quantity" SelectedValue="l.Quantity"
                                         name="l.Quantity">
                          </CodeTypeValue>-->

                          <input type="text" class="form-control text-align-right td-width-82px " placeholder="Quantity"
                                 id="l.Quantity"
                                 [(ngModel)]="l.Quantity" (input)="Qunatitychange(l)"
                                 name="l.Quantity" #Endometrium="ngModel"
                                 maxlength="5" pattern="^[\0-9,._\-?]*$">

                        </td>
                        <td class="text-align-center td-padding-tb padding-right-0px">{{l.UnitPrice| number:'1.0-2'|removeComma}}</td>
                        <td class="td-padding-tb text-align-center padding-right-0px"> <label class="margin-bottom-0px">{{l.Quantity * l.UnitPrice| number:'1.0-2'|removeComma}}</label></td>
                        <td class="td-padding-tb text-align-center max-width-10pe">
                          <!--<input *ngIf="l.DiscountAllowed" type="number" class="form-control text-align-right td-width-82px" placeholder=""
                          [(ngModel)]="l.discount"
                          maxlength="2" required>-->
                          <!--<CodeTypeValue *ngIf="l.DiscountAllowed" CodeType="5to25" class="bill"
                                         id="l.Discount" (keyChange)="Discountchange(l)"
                                         [(ngModel)]="l.Discount" SelectedValue="l.Discount"
                                         name="l.Discount">
                          </CodeTypeValue>-->
                          <input *ngIf="l.DiscountAllowed" type="text" class="form-control text-align-right td-width-82px " placeholder="Discount"
                                 id="l.Discount"
                                 [(ngModel)]="l.Discount" (input)="Discountchange(l)"
                                 name="l.Discount" #Endometrium="ngModel"
                                 maxlength="5" pattern="^[\0-9,._\-?]*$">


                          <label *ngIf="!l.DiscountAllowed" class="margin-bottom-0px">{{l.Discount}}</label>

                        </td>
                        <td class="text-align-center td-padding-tb padding-right-0px padding-left-0px">{{((l.Quantity * l.UnitPrice)-(l.Quantity * l.UnitPrice * (l.Discount / 100)))| number:'1.0-2'|removeComma}}</td>
                        <td class=" td-padding-tb text-align-center">

                          <!--<a class="nav-link-hand education-navlink font-size-16px color-Assign" title="Edit Plan" (click)="Editrow()" *ngIf="Add">
                            <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                          </a>-->
                          <!--<button type="submit" (click)="Editrow(l)" class="button-service-save font-size-16px color-secondary nav-link-hand margin-left-3px" title="Save" *ngIf="!l.Edit"><i class="fas fa-pencil-alt"></i></button>-->
                          <a *canUserAccess="['HL_BL_21']" (click)="delete(i,l)" class="nav-link-hand font-size-16px color-Rejected" title="Remove"><i class="far fa-trash-alt nav-link-hand"></i></a>
                          <!--<button type="submit" (click)="OnClear(l)" class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save" *ngIf="l.Edit"><i class="far fa-save"></i></button>
                          <button type="submit" (click)="OnClear(l)" class="button-service-save font-size-16px  nav-link-hand color-Rejected" title="Save" *ngIf="l.Edit"><i class="fa fa-times"></i></button>-->

                        </td>



                      </tr>
                    </tbody>



                  </table>
                </div>
              </div>
            </div>
          </div>


          <!--<div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <div class="card">


                <div class="card-header wh-header border-bottom padding-bottom-0px">
                  <div class="row border-bottom">
                    <div class="col-md-12">
                      <label class="margin-bottom-0px">Payment</label>
                    </div>

                  </div>
                </div>
                <div class="card-body padding-top-5px padding-bottom-0px">
                  <div class="row">

                      <div class="col-md-12 padding-right-0px">
                        <div class="table-component">
                          <div class="table-responsive">


                            <table class="table table-striped margin-left-zero width-100">

                              <thead class="">
                                <tr>

                                  <th class="min-width-0px"></th>
                                  <th class="th-width-170px">Amount</th>

                                  <th class="th-width-170px">Charges</th>
                                  <th class="th-width-170px">Ref.No</th>
                                  <th>Details</th>
                                </tr>
                              </thead>
                              <tbody class="table-body">

                                <tr>
                                  <td class="td-padding">

                                      <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                             [(ngModel)]="cash" />
                                      <i class="input-helper"></i>

                                      <label class="margin-bottom-0px position-absoulte margin-top-2px">Cash</label>



                                  </td>
                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cash">
                                  </td>
                                  <td class="text-align-right">
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cash">
                                  </td>

                                  <td class="td-padding ">

                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cash">

                                  </td>

                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cash">
                                  </td>



                                </tr>
                                <tr>
                                  <td class="td-padding">

                                    <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                           [(ngModel)]="card" />
                                    <i class="input-helper"></i>
                                    <label class="margin-bottom-0px position-absoulte margin-top-2px">Card</label>

                                  </td>
                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="card">
                                  </td>
                                  <td class="text-align-right">
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="card">
                                  </td>

                                  <td class="td-padding ">

                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="card">

                                  </td>

                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="card">
                                  </td>



                                </tr>
                                <tr>
                                  <td class="td-padding">


                                    <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                           [(ngModel)]="cheque" />
                                    <i class="input-helper"></i>
                                    <label class="margin-bottom-0px position-absoulte margin-top-2px">Cheque</label>

                                  </td>
                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cheque">
                                  </td>
                                  <td class="text-align-right">
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cheque">
                                  </td>

                                  <td class="td-padding ">

                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cheque">

                                  </td>

                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cheque">
                                  </td>



                                </tr>
                                <tr>
                                  <td class="td-padding">

                                    <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                           [(ngModel)]="demanddraft" />
                                    <i class="input-helper"></i>
                                    <label class="margin-bottom-0px position-absoulte margin-top-2px">Demand Draft</label>

                                  </td>
                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="demanddraft">
                                  </td>
                                  <td class="text-align-right">
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="demanddraft">
                                  </td>

                                  <td class="td-padding ">

                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="demanddraft">

                                  </td>

                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="demanddraft">
                                  </td>



                                </tr>
                                <tr>
                                  <td class="td-padding">

                                    <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                           [(ngModel)]="paytm" />
                                    <i class="input-helper"></i>
                                    <label class="margin-bottom-0px position-absoulte margin-top-2px">Paytm</label>

                                  </td>
                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="paytm">
                                  </td>
                                  <td class="text-align-right">
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="paytm">
                                  </td>

                                  <td class="td-padding ">

                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="paytm">

                                  </td>

                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="paytm">
                                  </td>



                                </tr>
                              </tbody>

                            </table>

                          </div>
                        </div>
                      </div>

                  </div>
                                         </div>






              </div>
            </div>
          </div>-->
        </div>
      </div>
      <!--<div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
          <div class="card">


            <div class="card-header wh-header border-bottom padding-bottom-0px">
              <div class="row border-bottom">
                <div class="col-md-4">
                  <label class="margin-bottom-0px">Discount : </label>
                </div>
                <div class="col-md-4">
                  <label class="margin-bottom-0px">Discount(%) :</label>
                </div>
                <div class="col-md-4">
                  <label class="margin-bottom-0px">Total :</label>
                </div>
              </div>
            </div>






          </div>
        </div>
      </div>-->




    </div>
  </div>

  <div class="columnbp3 background-white margin-top-17px">

    <div class="position-fixed-Activities3" *canUserAccess="['HL_BL_12']">
      <div class="row border-bottom-2px  background-store  margin-left-0px margin-right-0px">

        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 padding-left-8px">
          <div class="row margin-left-0px margin-right-0px margin-top-5px">
            <div class="col-md-9 padding-left-3px">
              <label class="margin-bottom-0px font-weight-normal">Select Store</label>
            </div>

          </div>


          <div class="row margin-left-0px margin-top-5px margin-bottom-5px">
            <div class="col-md-12 padding-left-0px my-profile-form">

              <!--<SelectStoreComponent OnStoreChange="StoreChanged()"></SelectStoreComponent>-->
              <CustomDataByRequestType RequestedType="AccessibleStores" FacilityCode={{FacilityCode}} ActorCode={{ActorCode2}} class="form-group" SelectedValue="StoreCode"
                                       [(ngModel)]="StoreCode"
                                       (dataLoaded)="StoreList_loaded"
                                       (keyChange)="onAssignedToActorCodesurgeon2($event)"
                                       name="StoreCodename" #sign2="ngModel">
              </CustomDataByRequestType>
            </div>
          </div>

        </div>

      </div>
      <div class="card">
        <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px padding-t-6px padding-left-8px">
          <div class="row">
            <div class="col-md-12 font-size-12px">
              Materials({{StoreName}})
            </div>
            <!--<div class="col-md-12 line-height-10px">
          <label class="margin-bottom-0px font-size-12px color-Assign" *ngIf="StoreName">({{StoreName}})</label>
        </div>-->
          </div>

          <div class="row margin-top-5px margin-bottom-10px margin-left-0px">
            <div class="col-md-10 padding-left-0px">
              <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>

            </div>



          </div>
        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px padding-bottom-0px">

          <div class="chatsd product-chart-wrapper product-chat-height-600 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
            <div class="table-component actor-table">

              <div class="table-responsive padding-right-11px">


                <table class="table table-striped table2">
                  <tbody>
                    <tr *ngFor="let l of pdata">
                      <td class="td-padding-2px">

                        <div class="row margin-left-zero margin-right" (click)="AddRow2(l)">
                          <div class="col-md-2  margin-tb-auto padding-right-0px padding-left-0px">
                            <button type="button"
                                    class="btn  btn-sm plus-button " id="FileUpload"
                                    name="upload">
                              <i class="fas fa-plus font-size-11p"></i>
                            </button>
                          </div>
                          <div class="col-md-10 margin-tb-auto padding-left-0px">
                            <label class="margin-bottom-0px color3">{{l.Description}}</label>

                          </div>
                        </div>


                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>




        </div>
      </div>
    </div>




  </div>


</div>
